import React, { JSX, useState } from 'react';
import Icons from 'components/atoms/Icons';

type ActionBarProps = {
  print?: boolean;
  copy?: boolean;
  suggestEdit?: boolean;
};

const ActionBar = (props: ActionBarProps): JSX.Element => {
  const { print, copy, suggestEdit } = props;
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href).then(
      () => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      },
      () => {
        console.log('failed to copy current url to clipboard');
      }
    );
  };

  return (
    <div className="action-bar" data-module="ProfileActions">
      {print && (
        <button className="print-btn" onClick={() => window.print()}>
          <Icons id="icon-print-new" /> Print
        </button>
      )}
      {copy && (
        <button className="copy-link-btn" onClick={copyToClipboard}>
          <Icons id="icon-copy-new" /> Copy Link
          <span className={`clipboard-notification ${copied ? 'active' : ''}`}>
            Link copied to clipboard
          </span>
        </button>
      )}
      {suggestEdit && (
        <a
          className="profile-update"
          href="https://www.osfhealthcare.org/provider-update"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icons id="icon-edit-new" /> Suggest an edit
        </a>
      )}
    </div>
  );
};

export default ActionBar;
